var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21V16.75L14.4667 3.575C14.6556 3.39167 14.8641 3.25 15.0924 3.15C15.3206 3.05 15.5606 3 15.8125 3C16.0644 3 16.3083 3.05 16.5444 3.15C16.7806 3.25 16.9852 3.4 17.1583 3.6L18.4569 5C18.6458 5.18333 18.7836 5.4 18.8701 5.65C18.9567 5.9 19 6.15 19 6.4C19 6.66667 18.9567 6.92083 18.8701 7.1625C18.7836 7.40417 18.6458 7.625 18.4569 7.825L6.01389 21H2ZM15.7889 7.8L17.1111 6.4L15.7889 5L14.4667 6.4L15.7889 7.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/edit-pencil-icon.5471cce120009f87bcdc7a963557cf49.svg";
export { ForwardRef as ReactComponent };